import { Input, TextArea } from "components/Form";
import React, { useState } from "react";
import "./../CoursePayments.scss";
import { decryptData, errorResponse, failResponse } from "config/config";
import ReactDatePicker from "react-datepicker";
import { useLocation, useNavigate } from "react-router-dom";
import {
  addRefundDetails,
  getRefundPaymentLinkUserDetails,
  updateBankAccountDetails,
} from "services/studentCoursePaymentRefunds";
import { dateFormat } from "config/utils";
import toast from "react-hot-toast";
import axios from "axios";
import { simpleDateFormat } from "config/utils";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import { Button, Modal } from "react-bootstrap";

export default function VerifyStudentAccountDetails() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const encryptedData = queryParams.get("params");
  // console.log(encryptedData)
  const navigate = useNavigate();


  const [data, setData] = useState({});
  const [userData, setUserData] = useState({});
  const [errorField, setErrorField] = useState({});

  const [loading, setLoading] = useState(false);
  const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();
  const [showPopup, setShowPopup] = useState(false);

  const getPaymentDetails = async () => {
    try {
      const res = await getRefundPaymentLinkUserDetails({
        encryptedstring: encryptedData,
      });
      if (res.code === 200) {
        setUserData({ ...res.data } || {});
        setData({
          ...data,
          bankName: res.data.bankname,
          addressIncludingBranch: res.data.addressincludingbranch,
          beneficiaryName: res.data.beneficiaryname,
          accountNumber: res.data.accountnumber,
          IFSCCode: res.data.ifsc,
        });
      } else {
        failResponse(res);
      }
    } catch (err) {
      errorResponse(err);
    }
  };

  React.useLayoutEffect(() => {
    getPaymentDetails();
  }, []);

  // console.log("enc",encryptedData)
  // console.log("dec",decryptData(encryptedData))

  //*********************Handel Validation********************************** */
  const handleValidation = () => {
    let errorField = {};
    let formIsValid = true;

    if (!data.IFSCCode) {
      errorField["IFSCCode"] = "Please Enter IFSC Code";
      formIsValid = false;
    }
    if (!data.accountNumber) {
      errorField["accountNumber"] = "Please Enter Account Number";
      formIsValid = false;
    }
    if (!data.addressIncludingBranch) {
      errorField["addressIncludingBranch"] =
        "Please Enter Account Bank Address";
      formIsValid = false;
    }
    if (!data.bankName) {
      errorField["bankName"] = "Please Enter Bank Name";
      formIsValid = false;
    }
    if (!data.beneficiaryName) {
      errorField["beneficiaryName"] = "Please Enter Beneficiary Name";
      formIsValid = false;
    }
    // if (!data.refundReason) {
    //   errorField["refundReason"] = "Please Enter Refund Reason";
    //   formIsValid = false;
    // }

    setErrorField(errorField);
    return formIsValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setSubmitLoading(true);
      if (handleValidation()) {
        try {
          const response = await updateBankAccountDetails({
            refundid: userData.refundid,
            studentid: userData.studentuserid,
            courseid: userData.courseId,
            bankname: data.bankName,
            addressincludingbranch: data.addressIncludingBranch,
            beneficiaryname: data.beneficiaryName,
            accountnumber: data.accountNumber,
            ifsc: data.IFSCCode,
          });

          if (response.code === 200) {
            setShowPopup(false);
            navigate("/thank-you")
            toast.success(response.message);
          } else {
            setShowPopup(false);
            toast.error(response.message);
            errorResponse(response.message);
          }
        } catch (error) {
          setShowPopup(false);
          console.error("Error fetching data: ", error);
        } finally {
          setShowPopup(false);
          setLoading(false);
        }
      } else {
        setShowPopup(false);
      }
      setSubmitLoading(false);
    } catch (err) {
      errorResponse(err);
      setShowPopup(false);
      setLoading(false);
    }
  };

  return (
    <>
      <section className="payment-refund-details spacing">
        <div className="container">
          {/* {!loading && ( */}
          <div className="subscription_content">
            <div className="course_detail">
              <h4>Update Bank Account Details</h4>
              <div className="form_group">
                <h5>Institute Details</h5>
                <div className="table-wrapper">
                  <table className="styled-table">
                    <tbody>
                      <tr>
                        <td>Shubhra Viraj Edutech Pvt. Ltd. </td>
                      </tr>
                      <tr>
                        <td>Phone - 9910812719 </td>
                      </tr>
                      <tr>
                        <td>GSTN: 07ABFCS4965B1ZB </td>
                      </tr>
                      <tr>
                        <td>
                          State Name: New Delhi - 110005 (State Code - 07){" "}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="form_group">
                <h5>Student Details</h5>
                <div className="table-wrapper">
                  <table className="styled-table">
                    <tbody>
                      <tr>
                        <td>Name</td>
                        <td>
                          {userData.studentfirstname || ""}{" "}
                          {userData.studentlastname || ""}
                        </td>
                      </tr>
                      <tr>
                        <td>Email</td>
                        <td>{userData.studentemail || ""}</td>
                      </tr>
                      <tr>
                        <td>Mobile</td>
                        <td>{userData.studentmobile || ""}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              {!!userData.sponsorname && (
                <div className="form_group">
                  <h5>Sponsor’s Details ( if Applicable ) </h5>
                  <div className="table-wrapper">
                    <table className="styled-table">
                      <tbody>
                        <tr>
                          <td>Name</td>
                          <td>{!!userData.sponsorname || ""}</td>
                        </tr>
                        {/* <tr>
                        <td>GST No.</td>
                        <td>d</td>
                      </tr>
                      <tr>
                        <td>Address</td>
                        <td>d</td>
                      </tr> */}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              <div className="form_group">
                <h5>Admission Details</h5>
                <div className="table-wrapper">
                  <table className="styled-table">
                    <tbody>
                      <tr>
                        <td>Course Name</td>
                        <td>{userData.coursename || ""}</td>
                      </tr>
                      <tr>
                        <td>Course Fees</td>
                        <td>{userData.coursefees || "0.00"}</td>
                      </tr>
                      <tr>
                        <td>Paid Fees</td>
                        <td>{userData.paidfees || "0.00"}</td>
                      </tr>
                      <tr>
                        <td>Invoice No.</td>
                        <td>{userData.invoiceno || ""}</td>
                      </tr>
                      <tr>
                        <td>Invoice Date</td>
                        <td>{dateFormat(userData.invoicedate)}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* <div className="form_group">
                    <h5>Why do you want a refund? </h5>
                    <div className="form_field_wrap">
                    <div className="form_field">
                        <label className="label">
                        Reason<span className="required mx-1"> *</span>
                        </label>

                        <TextArea
                        name="refundReason"
                        value={data.refundReason || ""}
                        onChange={(e) => {
                            const { name, value } = e.target;
                            setData({ ...data, [name]: value });
                        }}
                        placeholder="Enter Refund Reason"
                        className={`input form-control`}
                        error={errorField.refundReason}
                        />
                    </div>
                    </div>
                </div> */}
              <div className="form_group">
                <h5>Update Bank Account Details </h5>
                <div className="form_field_wrap">
                  <div className="form_field">
                    <Input
                      type="text"
                      name="bankName"
                      value={data.bankName || ""}
                      onChange={(e) => {
                        const { name, value } = e.target;
                        setData({ ...data, [name]: value });
                      }}
                      placeholder="Enter Bank Name"
                      className={`input form-control`}
                      error={errorField.bankName}
                      maxLength={50}
                      label={"Bank Name "}
                      required
                    />
                  </div>
                  <div className="form_field">
                    <Input
                      type="text"
                      name="IFSCCode"
                      value={data.IFSCCode || ""}
                      onChange={(e) => {
                        const { name, value } = e.target;
                        setData({ ...data, [name]: value });
                      }}
                      placeholder="Enter IFSC Code"
                      className={`input form-control`}
                      error={errorField.IFSCCode}
                      maxLength={50}
                      label={"IFSC Code"}
                      required
                    />
                  </div>
                </div>
                <div className="form_field_wrap">
                  <div className="form_field">
                    <Input
                      type="text"
                      name="accountNumber"
                      value={data.accountNumber || ""}
                      onChange={(e) => {
                        const { name, value } = e.target;
                        setData({ ...data, [name]: value.replace(/\D/g, "") });
                      }}
                      placeholder="Enter Account Number"
                      className={`input form-control`}
                      error={errorField.accountNumber}
                      maxLength={50}
                      label={"Account Number"}
                      required
                    />
                  </div>
                  <div className="form_field">
                    <Input
                      type="text"
                      name="beneficiaryName"
                      value={data.beneficiaryName || ""}
                      onChange={(e) => {
                        const { name, value } = e.target;
                        setData({ ...data, [name]: value });
                      }}
                      placeholder="Enter Beneficiary Name"
                      className={`input form-control`}
                      error={errorField.beneficiaryName}
                      maxLength={50}
                      label={"Beneficiary Name"}
                      required
                    />
                  </div>
                </div>
                <div className="form_field_wrap">
                  <div className="form_field">
                    <label className="label">
                      Account Bank Address
                      <span className="required mx-1"> *</span>
                    </label>
                    <TextArea
                      name="addressIncludingBranch"
                      value={data.addressIncludingBranch || ""}
                      onChange={(e) => {
                        const { name, value } = e.target;
                        setData({ ...data, [name]: value });
                      }}
                      placeholder="Enter Account Bank Address"
                      className={`input form-control`}
                      error={errorField.addressIncludingBranch}
                      // label={"Address Including Branch"}
                      required
                    />
                  </div>
                </div>
                <div className="form_field_wrap px-2 py-1 me-5 ">
                  <p style={{fontSize:"17px", fontWeight:"700"}}>
                    <strong className="text-danger">Note : </strong>Shubhra
                    Ranjan IAS study is not responsible if wrong details are
                    provided
                  </p>
                </div>

                <div className="button_wrap text-center">
                  <button
                    type="submit"
                    className="button"
                    onClick={() => setShowPopup(true)}
                    {...submitButtonElement}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* )} */}
        </div>
      </section>

      {/* /* Popup modal */}
      <Modal show={showPopup} onHide={() => setShowPopup(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Bank Account Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to proceed with the bank account details?</p>
        </Modal.Body>
        <Modal.Footer>
          <button  className="btn btn-outline-primary" onClick={() => setShowPopup(false)}>
            Cancel
          </button>
          <button className="btn btn-outline-danger" onClick={handleSubmit}>
            Submit
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
